import { useEffect, useState } from "react";
import "./DataSourceDropdown.scss";
import { icons } from "../../../components/common/utilities";
import { useDispatch } from "react-redux";
import { SET_SELECTED_DATA_TAG_SOURCE_ID } from "../DataTagConstants";

export default function DataSourceDropdown({
  dataSourceDetails,
  dataNodesDetails,
}) {
  const dataSource = (dataSourceDetails || []).filter(
    (item) => item?.hostType?.code !== "IAM_SERVICE" && item?.status?.code === "ACTIVE"
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  // Default selected = first node
  const [selectedNode, setSelectedNode] = useState(null);

  useEffect(() => {
  if (!selectedNode && dataSource.length > 0) {
    setSelectedNode(dataSource[0]);
    dispatch({
      type: SET_SELECTED_DATA_TAG_SOURCE_ID,
      payload: {
        id: dataSource[0].id,
        type: dataSource[0].type.code, 
      }
    });
  }
}, [dataSource, selectedNode, dispatch]);


  const toggleDropdown = () => setOpen(!open);

  const handleSelect = (item) => {
    setSelectedNode(item);
    dispatch({
      type: SET_SELECTED_DATA_TAG_SOURCE_ID,
      payload: {
        id: item.id,
        type: item.type.code,
      }
    });
    setOpen(false);
  };

  return (
    <div className="ds-dropdown-container">
      <div className="ds-dropdown-header" onClick={toggleDropdown}>
        <div className="left-section" title={selectedNode?.name}>
          <img
            src={icons[selectedNode?.type?.code] || icons["OTHER"]}
            alt="icon"
            className="ds-icon"
          />
          <span className="ds-title">{selectedNode?.name}</span>
        </div>
        <span className={`arrow ${open ? "rotate" : ""}`}>&#9662;</span>
      </div>

      {open && (
        <div className="ds-dropdown-list">
          {dataSource.map((item) => (
            <div
              key={item.id}
              className="ds-item"
              onClick={() => handleSelect(item)}
              title={item?.name}
            >
              <img
                src={icons[item.type.code] || icons["OTHER"]}
                alt="icon"
                className="ds-item-icon"
              />
              <span className="ds-sub-title">{item?.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
